import React, { useState } from 'react'
import { SearchOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import backButton from '../../../assets/images/back_button_arrow.svg';
import demandIcon from '../../../assets/images/icons/demand_icon.svg';
const { Option } = Select;

function resetFormView() { };

const CreateTag = ({ handlePageViewChange }) => {

    const onChange = (value) => {
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    const [searchValue, setSearchValue] = useState('');
    const [filterApply, setFilterApply] = useState({
        publisher: [],
    });

    const options = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const handleFilterApply = (type, value) => {
        setFilterApply((prev) => {
            const currentPublishers = prev.publisher;
            const isSelected = currentPublishers.includes(value);

            // Toggle selection
            const updatedPublishers = isSelected
                ? currentPublishers.filter((item) => item !== value)
                : [...currentPublishers, value];

            return { ...prev, publisher: updatedPublishers };
        });
    };

    // Filtering options based on search input
    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchValue)
    );



    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={demandIcon} alt="USP" /> Demand
                            </Link>
                        </li>
                        <li>Freewheel</li>
                        <li>Zones</li>
                        <li className="primary">New Zone</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            Create Tag
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Configuration Details</label>
                                    <p className="sub_text">Select site and format.</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Site/App * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Format Type * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">
                                                    Response Code
                                                </label>
                                                <Radio.Group className="form_radio equal_space">
                                                    <Radio className="radio_btn" value="Website">
                                                        VAST
                                                    </Radio>
                                                </Radio.Group>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Video Preferences</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <div className="form_content_block--group">
                                        <label className="form_label">
                                            Protocol
                                        </label>
                                        <Radio.Group className="form_radio equal_space">
                                            <Radio className="radio_btn" value="Website">
                                                VAST 2.0
                                            </Radio>
                                            <Radio className="radio_btn" value="Inapp">
                                                VAST 3.0
                                            </Radio>
                                            <Radio className="radio_btn" value="CTV">
                                                VAST 4
                                            </Radio>
                                        </Radio.Group>
                                    </div>
                                    <div className="form_content_block--group">
                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                            <label className="form_label">MME Types * </label>
                                            <Select
                                                id="adcodeSelect"
                                                value={filterApply.publisher}
                                                popupClassName='diff_select_d2 --full'
                                                // open={true}
                                                showSearch={false}
                                                placeholder='- Select -'
                                                className="form_select basic"
                                                mode='multiple'
                                                maxTagCount='responsive'
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="custom_inside_searchbar_d2">
                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                        </div>
                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filteredOptions.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        <div
                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={filterApply.publisher.includes(option.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                {option.label}
                                                            </Checkbox>
                                                        </div>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                    <Row gutter={16}>
                                        <Col span={12} className='position-relative'>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label">Ad Duration *</label>
                                                <Input className='form_control basic' autocomplete="off" placeholder='From' suffix={
                                                    <em className='input_inside_text_d2'>second(s)</em>
                                                } />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className='divider_d2'>-</div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label invisible">Per *</label>
                                                <Input className='form_control basic' autocomplete="off" placeholder='To' suffix={
                                                    <em className='input_inside_text_d2'>second(s)</em>
                                                } />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Basic Details</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Ad Tag Name * </label>
                                                <Input className='form_control basic ' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Discard </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Create Tag</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateTag
